var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91662 5.67767C5.23881 5.35549 5.76117 5.35549 6.08335 5.67767L11 10.5943L15.9166 5.67767C16.2388 5.35549 16.7612 5.35549 17.0834 5.67767C17.4055 5.99985 17.4055 6.52222 17.0834 6.8444L12.1667 11.761L17.0834 16.6777C17.4055 16.9999 17.4055 17.5222 17.0834 17.8444C16.7612 18.1666 16.2388 18.1666 15.9166 17.8444L11 12.9278L6.08335 17.8444C5.76117 18.1666 5.23881 18.1666 4.91662 17.8444C4.59444 17.5222 4.59444 16.9999 4.91662 16.6777L9.83326 11.761L4.91662 6.8444C4.59444 6.52222 4.59444 5.99985 4.91662 5.67767Z",
    fill: "#415066"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a074f3be35b8489f5ae85c3715a23240.svg";
export { ForwardRef as ReactComponent };